exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".pokemon-img {\n  display: block;\n  width: auto;\n  height: 550px;\n  margin: auto; }\n\n.carousel {\n  background-color: #7DF9FF; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/Home/Home.styles.scss
// module id = 159
// module chunks = 0